module.exports = __webpack_public_path__ + "img/haider_ahmed_ibm1-min.75a06859.jpg";